import React, { useState, useEffect, useRef } from "react";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import {
  getCategoryMasterData,
  getFileTypeData,
  postClientsMedicalCarrierDataFileUpload,
  GetFileTypeByCarrier,
  GetCarrierFileType,
} from "../../../api/User/commonApi";
import { getCarrierData } from "../../../api/User/Hub/medicalcredentialsApi";
import Fontstyling, {
  clientListDrpDwnStyles,
} from "../../../components/common/comman";
import { Col, Form, Row } from "react-bootstrap";
import * as yup from "yup";
import { Spinner } from "react-bootstrap";
import toastFile from "../../../Service/ToastFile";
import { useDispatch } from "react-redux";
import {
  clearClientData,
  selectedClientData,
} from "../../../Redux/Reducer/ClientDataReducer";
import Required from "../../../components/Required";
import ClientList from "../../../components/common/ClientList";

const schema = yup.object().shape({
  // client: yup
  //   .string()
  //   .notOneOf(["SELECT CLIENT NAME"], "Please select client")
  //   .required("Please select client"),
  carrier: yup
    .string()
    .notOneOf(["Select Carrier"], "Please select carrier")
    .required("Please select carrier"),
  // filecategory: yup
  //   .string()
  //   .notOneOf(["Select File Category"], "Please select file category")
  //   .required("Please select file category"),
  filetype: yup
    .string()
    .notOneOf(["Select File Type"], "Please select file type")
    .required("Please select file type"),
  file: yup.mixed().required("Please upload file"),
});

const ImportCarrierFile = () => {
  const UD_id = useSelector((state) => state.userDetails.value?.UD_id);
  const [carrierData, setCarrierData] = useState([]);
  const [isclientValidate, setIsclientValidate] = useState(false);
  const [selectedClientvalue, setSelectedClientValue] = useState({
    value: 0,
    label: "SELECT CLIENT NAME",
  });
  const [categoryData, setCategoryData] = useState([]);
  const [fileTypesData, setFileTypesData] = useState([]);
  const [fileValidation, setFileValidation] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [clientData, setClientData] = useState([]);
  const [empty, setEmpty] = useState(false);

  const dispatch = useDispatch();
  const formRef = useRef();
  const fileRef = useRef();
  const buttonRef = useRef();

  useEffect(() => {
    getCarrier();
    getCategoryMaster();
    getFileTypes();
  }, []);

  const handleFormSubmit = (values, onSubmitProps) => {
    if (selectedClientvalue.value === 0) {
      return setIsclientValidate(true);
    }
    buttonRef.current.disabled = true;
    const { client, carrier, filetype, file } = values;
    console.log(values)
    setIsLoading(true);
    if (file === null) {
      setFileValidation("required");
      setIsLoading(false);
      buttonRef.current.disabled = false;
    } else if (fileValidation) {
      toastFile("invalid file");
      setIsLoading(false);
      buttonRef.current.disabled = false;
    } else {
      let filetypeObj=JSON.parse(filetype)
      postClientsMedicalCarrierDataFileUpload(selectedClientvalue.value,carrier,filetypeObj.fileTypeID,filetypeObj.fileTypeName,UD_id,file)
        .then((res) => {
          if (res?.status === 200 || res?.status === 204) {
            toastFile(res.data, "success");

            //buttonRef.current.disabled = false;
            for (const element of formRef.current) element.selectedIndex = 0;
            //fileRef.current.value = null;
          }
        })
        .catch((err) => {
          toastFile(err?.response?.data);
          //setIsLoading(false);
        })
        .finally((res) => {
          setIsLoading(false);
          setTimeout(() => {
            onSubmitProps.resetForm();
            buttonRef.current.disabled = false;
            // for (const element of formRef.current) element.selectedIndex = 0;
            fileRef.current.value = null;
            // setFileTypesData([]);
          }, 200);
        });
    }
  };

  const getCarrier = () => {
    getCarrierData().then((res) => {
      if (res?.status === 200 || res?.status === 204) {
        let sortData = res.data.sort((a, b) => {
          if (a.CarrierName < b.CarrierName) {
            return -1;
          }
          if (a.CarrierName > b.CarrierName) {
            return 1;
          }
          return 0;
        });
        // let formatedData = sortData.map((obj) => {
        //   return { value: obj.CarrierID, label: obj.CarrierName };
        // });
        setCarrierData(sortData);
      }
    });
  };

  const getCategoryMaster = () => {
    getCategoryMasterData()
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          setCategoryData(
            res.data.sort((a, b) =>
              a.CategoryName.localeCompare(b.CategoryName)
            )
          );
        }
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  const getFileTypes = () => {
    GetCarrierFileType().then((res) => {
      if (res?.status === 200 || res?.status === 204) {
        setFileTypesData(
          res.data.data.sort((a, b) => a.fileTypeName.localeCompare(b.fileTypeName))
        );
      }
    });
  };

  const handleClientChange = (option) => {
    setSelectedClientValue(option);
    setIsclientValidate(true);
    if (option.value === 0) {
      dispatch(clearClientData(null));
      return;
    }
    let findedClientData = clientData.find(
      (item) => item.clientID === option.value
    );
    dispatch(selectedClientData(findedClientData));
  };

  return (
    <>
      <div className="mb-3" style={Fontstyling.heading}>
        <label style={{ fontSize: 15 }}>Import File Here</label>
      </div>
      <Formik
        validationSchema={schema}
        initialValues={{
          client: "Select Client",
          carrier: "Select Carrier",
          // filecategory: "Select File Category",
          filetype: "Select File Type",
          file: null,
        }}
        onSubmit={handleFormSubmit}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          setFieldValue,
          setFieldError,
          setValues,
          resetForm,
          errors,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Row className="gap-3 mb-2">
              <Col md={3}>
                <Form.Group>
                  <Form.Label
                    htmlFor="client"
                    style={Fontstyling.label}
                    className="form-label text-nowrap"
                  >
                    Client
                    <Required />
                  </Form.Label>
                  <ClientList
                    clientData={clientData}
                    setClientData={setClientData}
                    // customStyles={clientListDrpDwnStyles}
                    customStyles={{
                      ...clientListDrpDwnStyles,
                      control: (base) => ({
                        ...clientListDrpDwnStyles.control(base),
                        border: `1px solid ${
                          isclientValidate && selectedClientvalue?.value === 0
                            ? "red"
                            : "lightgrey"
                        }`,
                      }),
                    }}
                    handleClientChange={handleClientChange}
                    selectedClientvalue={selectedClientvalue}
                    setSelectedClientValue={setSelectedClientValue}
                  />
                  {isclientValidate && selectedClientvalue?.value === 0 && (
                    <Form.Label className="invalid-feedback d-block">
                      Please select client
                    </Form.Label>
                  )}
                </Form.Group>
              </Col>
              <Col sm={4}>
                <Form.Group>
                  <Form.Label
                    htmlFor="carrier"
                    style={Fontstyling.label}
                    className="form-label text-nowrap"
                  >
                    Carrier
                    <Required />
                  </Form.Label>
                  {/* <ReactSelect
                    options={carrierData}
                    styles={customStyles}
                    menuShouldScrollIntoView={false}
                    placeholder="Select Carrier"
                    onChange={(e) => {
                      handleChange(e);
                      setSelectedCarrier(e)
                      if (e.target.value === "Select Carrier") return;
                      GetFileTypeByCarrier(e.target.value).then((res) => {
                        if (res?.status === 200 || res?.status === 204) {
                          setFileTypesData(
                            res.data.sort((a, b) =>
                              a.FileTypeName.localeCompare(b.FileTypeName)
                            )
                          );
                        }
                      });
                    }}
                    value={selectedCarrier}
                  /> */}
                  <Form.Select
                    className="form-select rounded-0 py-1"
                    id="carrier"
                    style={{ ...Fontstyling.label, padding: "10px" }}
                    name="carrier"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      // setFieldValue("filetype", "Select File Type");
                      handleChange(e);
                      // if (e.target.value === "Select Carrier") return;
                      // GetFileTypeByCarrier(e.target.value).then((res) => {
                      //   if (res?.status === 200 || res?.status === 204) {
                      //     setEmpty(!res.data.length);
                      //     setFileTypesData(
                      //       res.data.sort((a, b) =>
                      //         a.FileTypeName.localeCompare(b.FileTypeName)
                      //       )
                      //     );
                      //   }
                      // });
                    }}
                    value={values.carrier}
                    isInvalid={
                      values.carrier === "Select Carrier" && touched.carrier
                    }
                  >
                    <option value={"Select Carrier"}>Select Carrier</option>
                    {carrierData.map((item, index) => (
                      <option value={item.CarrierID} key={index}>
                        {item.CarrierName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.carrier}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col sm={4}>
                <Form.Group>
                  <Form.Label
                    htmlFor="filetype"
                    style={Fontstyling.label}
                    className="form-label text-nowrap"
                  >
                    File Type
                    <Required />
                  </Form.Label>
                  <Form.Select
                    className="form-select rounded-0 py-1"
                    id="filetype"
                    style={Fontstyling.label}
                    name="filetype"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.filetype}
                    isInvalid={
                      (values.carrier !== "Select Carrier" && empty) ||
                      (errors.filetype && touched.filetype)
                    }
                  >
                    <option value={"Select File Type"}>Select File Type</option>
                    {/* {values.carrier !== "Select Carrier" && */}
                    {fileTypesData?.map((item, index) => {
                        return (
                          <option value={JSON.stringify(item)} key={index}>
                            {item.fileTypeName}
                          </option>
                        );
                      })}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {(values.carrier !== "Select Carrier" &&
                      empty &&
                      "No file type exist on this carrier, please select different carrier") ||
                      errors.filetype}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              {/* <Col sm={4}>
                <Form.Group>
                  <Form.Label
                    htmlFor="filecategory"
                    style={Fontstyling.label}
                    className="form-label text-nowrap"
                  >
                    File Category
                    <Required />
                  </Form.Label>
                  <Form.Select
                    className="form-select rounded-0 py-1"
                    id="filecategory"
                    style={Fontstyling.label}
                    name="filecategory"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.filecategory}
                    isInvalid={
                      values.filecategory === "Select File Category" &&
                      touched.filecategory
                    }
                  >
                    <option value={"Select File Category"}>
                      SELECT FILE CATEGORY
                    </option>
                    {categoryData.map((item, index) => (
                      <option value={item.CategoryID} key={index}>
                        {item.CategoryName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.filecategory}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col> */}
            </Row>
            <Row className="gap-3">
             
              <Col sm={4}>
                <Form.Group>
                  <Form.Label
                    htmlFor="file"
                    style={Fontstyling.label}
                    className="form-label text-nowrap"
                  >
                    File
                    <Required />
                  </Form.Label>
                  <Form.Control
                    className="rounded-0 py-1"
                    style={Fontstyling.label}
                    type="file"
                    name="file"
                    id="file"
                    accept=".xlsx, .xls"
                    isInvalid={fileValidation || (errors.file && touched.file)}
                    ref={fileRef}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (!e.target.value) {
                        setFileValidation("");
                      } else if (
                        !(
                          file.type === "application/vnd.ms-excel" ||
                          file.type ===
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        )
                      ) {
                        setFileValidation(
                          "Please select file type .xls or .xlsx"
                        );
                        setFieldValue("file", e.currentTarget.files[0]);
                      } else {
                        setFileValidation("");
                        setFieldValue("file", e.currentTarget.files[0]);
                      }
                    }}
                  />
                  {/* {fileValidation ? ( */}
                  <Form.Control.Feedback
                    className="text-danger"
                    style={{
                      fontSize: ".875em",
                      fontWeight: 500,
                      letterSpacing: "-0.5px",
                      fontFamily: "Arial",
                      color: "#dc3545",
                      marginTop: "0.25rem",
                      fontFamily:
                        "system-ui,-apple-system,Segoe UI,Roboto,Helvetica Neue,Noto Sans,Liberation Sans,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color emoji",
                    }}
                    type="invalid"
                  >
                    {fileValidation || errors.file}
                  </Form.Control.Feedback>
                  {/* // ) : null} */}
                  {/* {errors.file && (
                    <div className="text-danger" style={Fontstyling.errorlabel}>
                      {errors.file}
                    </div>
                  )} */}
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex align-items-center gap-3 mt-4">
              <button
                className="text-nowrap"
                style={{ ...Fontstyling.savebutton }}
                type="submit"
                disabled={isLoading}
                ref={buttonRef}
                onClick={() =>
                  selectedClientvalue.value === 0
                    ? setIsclientValidate(true)
                    : null
                }
              >
                {isLoading ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="false"
                      style={{ marginRight: "5px" }}
                    />
                    <span>Uploading...</span>
                  </div>
                ) : (
                  "Upload File"
                )}
              </button>
              <button
                className="text-nowrap"
                style={{ ...Fontstyling.cancelbutton }}
                type="button"
                onClick={() => {
                  setValues({
                    client: 0,
                    carrier: 0,
                    filecategory: 0,
                    filetype: 0,
                    file: null,
                  });
                  resetForm();
                  setFieldError("file", "");
                  setFileTypesData([]);
                  setFileValidation("");
                  fileRef.current.value = null;
                }}
              >
                Cancel
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ImportCarrierFile;
